// Helpers for the order page on phones and tablets.

export const isCoarsePointer = (win = typeof window === "undefined" ? undefined : window) =>
  Boolean(win?.matchMedia?.("(pointer: coarse)")?.matches);

// iPadOS reports itself as "MacIntel", so also check for touch points.
export const isIOSDevice = (nav = typeof navigator === "undefined" ? undefined : navigator) => {
  if (!nav) return false;
  return /iPad|iPhone|iPod/.test(nav.userAgent || "") ||
    (nav.platform === "MacIntel" && Number(nav.maxTouchPoints) > 1);
};

export const withMaximumScale = (content = "") => {
  const parts = String(content)
    .split(",")
    .map((part) => part.trim())
    .filter((part) => part && !/^maximum-scale\s*=/i.test(part));
  return [...parts, "maximum-scale=1"].join(", ");
};

// iOS Safari zooms into a focused field whose font is under 16px and stays
// zoomed after typing. With maximum-scale=1 it skips that auto-zoom but still
// lets the user pinch-zoom, so this is safe to apply on iOS only. Android
// would block pinch-zoom entirely, so it is left alone there.
// Returns a function that restores the original viewport.
export const preventIOSInputZoom = (
  doc = typeof document === "undefined" ? undefined : document,
  nav = typeof navigator === "undefined" ? undefined : navigator,
) => {
  const meta = doc?.querySelector?.('meta[name="viewport"]');
  if (!meta || !isIOSDevice(nav)) return () => {};
  const original = meta.getAttribute("content");
  meta.setAttribute("content", withMaximumScale(original || "width=device-width, initial-scale=1"));
  return () => {
    if (original === null) meta.removeAttribute("content");
    else meta.setAttribute("content", original);
  };
};
